// File name : App.js

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import axios from 'axios';
// import ReactMarkdown from 'react-markdown'; // react-markdown 추가
// import { Helmet } from 'react-helmet'; // Helmet 라이브러리 추가
import { signInWithPopup} from 'firebase/auth';
import { auth, googleProvider} from './firebase';
import Intro from './Intro';
import Home from './Home'; // Home 컴포넌트 추가

import HomeBookmark from './HomeBookmark';
import HomeLearnPlay from './HomeLearnPlay';
import HomeUtility from './HomeUtility';
import HomeShared from './HomeShared';

import Diary from './Diary';
import ImageConvert from './ImageConvert';
// import MyMemory from './MyMemory';
import Manage from './Manage';
import HeadsUp from './HeadsUp';
import HeadsUpBasic from './HeadsUpBasic'; 
import WordStudyToeic from './WordStudyToeic'; 
import WordStudyGRE from './WordStudyGRE'; 
import WordStudySAT from './WordStudySAT'; 
import WordStudyHS from './WordStudyHS';  

import WaterMark from './WaterMark'; 
import Clipboard from './Clipboard';
import ScanPage from './ScanPage';
import Homehuggingface from './Homehuggingface';
import GenToken from './GenToken';

import SpeechToText from './SpeechToText'; 
import YoutubePlay from './YoutubePlay';
import MusicPlay from './MusicPlay';
import DiaryDetail from './DiaryDetail';
import QRclient from './QRclient';
import QRScanner from './QRmessaging/QRScanner';
import DirectQRCreator from './QRmessaging/DirectQRCreator';
import HFLedger from './HFLedger';
import ConvertToCanon from './ConvertToCanon';
import Thumbnail from './Thumbnail';
import BlogEditor from './BlogEditor';
import GuitarSimulator from './GuitarSimulator';
import AudioSpectrum from './AudioSpectrum';

import WorldLandCafe from './WorldLandCafe';

// import WordStudySAT_rand from './WordStudySAT_rand'; 


import './styles-global.css';
import './App.css'; 

// App.js의 YoutubeSharePage 컴포넌트 수정
const YoutubeSharePage = ({ language, user, SERVER_ROOT }) => {
  useEffect(() => {
    // URL 파라미터 가져오기
    const urlParams = new URLSearchParams(window.location.search);
    const videoId = urlParams.get('video');
    const trackId = urlParams.get('trackId');
    
    // 로컬 스토리지에 정보 저장 (메인 페이지에서 사용할 수 있도록)
    if (trackId) {
      localStorage.setItem('shared_youtube_track_id', trackId);
    }
    
    if (videoId) {
      localStorage.setItem('shared_youtube_video_id', videoId);
    }
    
    // 메타태그 처리를 위한 서버 엔드포인트로 리다이렉트
    window.location.href = `${SERVER_ROOT}/share/youtube?video=${videoId || ''}&trackId=${trackId || ''}&t=${Date.now()}`;
  }, [SERVER_ROOT]);
  
  return (
    <div style={{textAlign: 'center', padding: '20px'}}>
      <p>{language === 'KR' ? '유튜브 영상을 불러오는 중입니다...' : 'Loading YouTube video...'}</p>
    </div>
  );
};

function App() {
  const [webpageData, setWebpageData] = useState([]);
  const [sloganText, setSloganText] = useState(''); // Slogan text 상태 추가 

  // const [menuItems, setMenuItems] = useState([]); 
  // const [currentIndex, setCurrentIndex] = useState(-1);
  // const [selectedItem, setSelectedItem] = useState(null);
  // const [showDetails, setShowDetails] = useState(false);
  // const [viewFile, setViewFile] = useState(false);
  // const [animationFinished, setAnimationFinished] = useState(false); 
  // const [isHovered, setIsHovered] = useState(false); 
  // const [isTouching, setIsTouching] = useState(false); 
  // const [isAnimating, setIsAnimating] = useState(false); 
  const [user, setUser] = useState(null); // 로그인된 사용자 상태 추가 
  const storedLanguage = localStorage.getItem('language'); // 저장된 language 읽기
  const [language, setLanguage] = useState(storedLanguage || 'KR'); // localStorage에 있으면 사용, 없으면 기본값 KR
  const [userIp, setUserIp] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [countryCode, setCountryCode] = useState('');
  const [dataReady, setDataReady] = useState(false); // 데이터 준비 상태를 추적하는 새로운 상태
  const [showYoutube, setShowYoutube] = useState(false); // Youtube 표시 상태 추가

  // let SERVER_ROOT = 'https://www.doldari.com:3001';

  // const LOCAL_MODE = true;

  // if (LOCAL_MODE) {
  //   SERVER_ROOT = 'http://localhost:3001';
  // } 

  const SERVER_ROOT = process.env.REACT_APP_SERVER_ROOT || 'http://localhost:3001'; 

  // 모바일 감지 함수
  const isMobile = () => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const isMobileDevice = isMobile();  

  // const isMobile = () => {
  //   return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  // };

  // Google Provider에 매번 계정을 선택하도록 설정
  googleProvider.setCustomParameters({ prompt: 'select_account' });

  // 데이터 로딩 상태를 확인하고 업데이트하는 함수
  const checkDataReady = () => {
    console.log("Checking data ready with values:", { userIp, countryCode, user });
    // user 값이 있고, userIp 또는 countryCode가 있으면 준비 완료로 간주
    if (user && (userIp || countryCode)) {
      console.log("Setting data ready to TRUE");
      setDataReady(true);
      setIsLoading(false);
    }
  };
 
  // 국가 정보를 가져와 language 설정
  useEffect(() => {
    const fetchCountryInfo = async () => {
      try {
        const response = await axios.get("https://ipapi.co/json/");
        const detectedCountryCode = response.data.country_code;
        setCountryCode(detectedCountryCode);

        if (!storedLanguage) {
          setLanguage(detectedCountryCode === "KR" ? "KR" : "EN");
        }

        updateUserCountryAndVisits(detectedCountryCode);
        checkDataReady(); // 데이터 준비 상태 확인
      } catch (error) { 
        console.error("Error fetching country information:", error);
        // 오류가 발생해도 기본값 설정
        setCountryCode(countryCode || 'UNKNOWN');
        checkDataReady(); // 오류가 발생해도 데이터 준비 상태 확인
      }
    }; 

    fetchCountryInfo();
  }, [storedLanguage]);

  const updateUserCountryAndVisits = async (detectedCountryCode) => {
    try {
      const storedUser = JSON.parse(localStorage.getItem("user"));

      if (storedUser) {
        const updatedUser = {
          uid: storedUser.uid,
          countryCode: detectedCountryCode,
        };

        await axios.put(`${SERVER_ROOT}/api/users/visit`, updatedUser);

        console.log("User visit updated successfully.");
      } else {
        console.warn("User is not logged in.");
      }
    } catch (error) {
      console.error("Error updating user country and visits:", error);
    }
  };

  useEffect(() => {
      axios.get(`${SERVER_ROOT}/api/userip`) // Replace SERVER_ROOT with your server URL
          .then((response) => {
              console.log('Fetched IP:', response.data.ip); // Debug log
              setUserIp(response.data.ip); 
              checkDataReady(); // 데이터 준비 상태 확인
          })
          .catch((error) => {
              console.error('Error fetching IP address:', error);
              // 오류가 발생해도 기본값 설정
              setUserIp(userIp || '0.0.0.0');
              checkDataReady(); // 오류가 발생해도 데이터 준비 상태 확인
          });
  }, []);

  const checkAndCreateUser = async () => {
    try {
      // 먼저 정식 사용자 확인
      const regularUser = JSON.parse(localStorage.getItem('user'));
      
      if (regularUser) {
        console.log('Regular user found:', regularUser);
        setUser(regularUser);
        return;
      }
      
      // 임시 사용자 확인
      const storedUser = JSON.parse(localStorage.getItem('uk_user'));
    
      if (!storedUser) {
        const newUser = await createTemporaryUser(); // await 추가
    
        try {
          // 서버에 사용자 데이터 저장
          await axios.post(`${SERVER_ROOT}/api/users`, newUser);
    
          setUser(newUser);
          localStorage.setItem('uk_user', JSON.stringify(newUser));
          console.log('Temporary user created:', newUser);
        } catch (error) {
          console.error('Error creating user:', error);
          // 오류가 발생해도 사용자 상태 설정
          setUser(newUser);
        }
      } else {
        console.log('Temporary user found:', storedUser);
        setUser(storedUser);
      }
    } catch (error) {
      console.error('Error in checkAndCreateUser:', error);
      // 오류 발생 시 기본 사용자 생성
      const fallbackUser = await createTemporaryUser(); // await 추가
      setUser(fallbackUser);
    } finally {
      // 함수 실행 후 항상 체크
      setTimeout(checkDataReady, 100);
    }
  };

  useEffect(() => { 
    checkAndCreateUser(); // 비동기 함수 호출
  }, []);

  // Temporary User 생성 함수
  // Temporary User 생성 함수
  // Temporary User 생성 함수 - 비동기로 변경
  const createTemporaryUser = async () => {
    try {
      // 서버에서 마지막 사용자 ID 가져오기
      const response = await axios.get(`${SERVER_ROOT}/api/last-user-id`);
      const nextId = response.data.lastId + 1;
      
      const uid = generateUid();
      const displayName = `user${nextId}`; // nextId를 사용하여 displayName 생성
      const email = `${displayName}@doldari.com`;

      return {
        uid,
        displayName,
        email,
        profile_picture_url: '/images/uk.png',
        subscription: 'free', 
      };
    } catch (error) {
      console.error('Error creating temporary user:', error);
      // 오류 발생 시 기본 방식으로 생성
      const uid = generateUid();
      const displayName = `user${uid.substring(3)}`;
      const email = `${displayName}@doldari.com`;
      
      return {
        uid,
        displayName,
        email,
        profile_picture_url: '/images/uk.png',
        subscription: 'free',
      };
    }
  };

  // UID 생성 함수 (Google UID와 유사한 방식, 'uk_' 접두사 추가)
  const generateUid = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const length = 28; // Google UID와 동일한 길이
    let randomUid = 'uk_';
    for (let i = 0; i < length; i++) {
      randomUid += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return randomUid;
  };

  useEffect(() => {
    console.log('Current user:', user);
    checkDataReady(); // 사용자 정보가 변경될 때 데이터 준비 상태 확인
    
    // URL에서 비디오 ID 확인 (공유된 링크 처리)
    const params = new URLSearchParams(window.location.search);
    const videoId = params.get('video');
    
    if (videoId) {
      // videoId가 있으면 로컬 스토리지에 저장 (YoutubePlay 컴포넌트에서 사용)
      localStorage.setItem('shared_youtube_video_id', videoId);
      
      // URL에서 파라미터 제거 (필요시)
      // window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [user]);

  // Check localStorage for a user on initial load
  useEffect(() => {
    try {
      const storedUser = JSON.parse(localStorage.getItem('user'));
      if (storedUser) {
        console.log('Found stored user:', storedUser);
        setUser(storedUser); // Restore the user from localStorage if found
      } else {
        const ukUser = JSON.parse(localStorage.getItem('uk_user'));
        if (ukUser) {
          console.log('Using uk_user as fallback:', ukUser);
          setUser(ukUser); // Use uk_user as fallback if available
        }
      }
    } catch (error) {
      console.error('Error loading user from localStorage:', error);
    }
  }, []); 

  // 데이터 준비 상태가 변경될 때마다 로그 출력
  useEffect(() => {
    console.log('Data ready:', dataReady);
    console.log('User:', user);
    console.log('Country code:', countryCode);
    console.log('User IP:', userIp);
    
    // 종속성이 변경될 때마다 데이터 준비 상태를 다시 확인
    checkDataReady();
  }, [user, countryCode, userIp]);

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
  
      const loggedInUser = {
        uid: result.user.uid,
        displayName: result.user.displayName,
        email: result.user.email, 
        profile_picture_url: result.user.photoURL,
        subscription: 'free' // 기본값
      };
  
      // 서버에 사용자 데이터 저장
      await axios.post(`${SERVER_ROOT}/api/users`, loggedInUser);
  
      setUser(loggedInUser);
      localStorage.setItem('user', JSON.stringify(loggedInUser));
      checkDataReady(); // 데이터 준비 상태 확인
    } catch (error) {
      console.error('Google Login Error:', error);
    }
  };
  

  const handleNaverLogin = () => {
    alert('Naver login is currently under development.'); 
  };

  // Function to handle logout
  const handleLogout = async () => {
    try {
      await auth.signOut();
      setUser(null);
      localStorage.removeItem('user'); // Remove user from localStorage on logout

      checkAndCreateUser(); // 비동기 함수 호출
    } catch (error) {
      console.error('Logout Error:', error);
    }
  };

  const handleLanguageToggle = () => {
    setLanguage((prevLanguage) => {
      const newLanguage = prevLanguage === 'KR' ? 'EN' : 'KR';
      localStorage.setItem('language', newLanguage); // localStorage에 저장
      return newLanguage;
    });
  }; 

  const handleYoutubeToggle = () => { 
    setShowYoutube(prev => !prev);
  };
  

  const getValueByName = (dataArray, name) => {
    const record = dataArray.find(record => record.name === name);
    return record ? record.value : null; // name이 없을 경우 null 반환
  };
  
  useEffect(() => { 
    const tableName = language !== 'KR' ? 'webpage_EN' : 'webpage';

    console.log(tableName);

    axios.get(`${SERVER_ROOT}/api/${tableName}`) 
      .then(response => {
        console.log(`Fetched ${tableName} data:`, response.data); // 데이터 출력
        setWebpageData(response.data);

        console.log(webpageData);

        // name이 'App.js_slogun'인 record 찾기
        const sloganRecord = response.data.find(item => item.name === 'App.js_slogun');
        if (sloganRecord) {
          setSloganText(sloganRecord.value); // 상태 업데이트
        } 
      })
      .catch(error => {
        console.error("Error fetching webpage data:", error);
      });
  }, [language]);


  // 로딩 화면 컴포넌트
  const LoadingScreen = () => (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <div className="loading-text">{language === 'KR' ? '로딩 중...' : 'Loading...'}</div>
      {/* 디버깅 정보 표시 (개발 중에만 사용, 배포 시 제거) */}
      <div style={{ marginTop: '20px', fontSize: '12px', color: '#666' }}>
        <p>User: {user ? 'Loaded' : 'Not loaded'}</p>
        <p>Country: {countryCode || 'Not loaded'}</p>
        <p>IP: {userIp || 'Not loaded'}</p>
        <button 
          onClick={() => {
            setDataReady(true);
            setIsLoading(false);
          }}
          style={{ 
            marginTop: '10px', 
            padding: '5px 10px', 
            backgroundColor: '#f0f0f0', 
            border: '1px solid #ccc', 
            borderRadius: '4px' 
          }}
        >
          강제 로딩 완료
        </button>
      </div>
    </div>
  );

  return ( 
    <Router>
      <div className="App">
        <div className="topmenu">  
          <Link to="/">
            <img src="/resources/newlogo_doldari3.png" alt="Doldari" className="logo" />
          </Link>

          <button onClick={handleLanguageToggle} className="language-button">
            {language === 'KR' ? 'ENGLISH' : '한국어'}
          </button>  

          

          {!isMobileDevice && (
            <div className="home-Greetings" style={{fontSize: '18px', color: 'gray', opacity: '50%', }}> 
                {language === 'KR' ? '나에게 필요한 모든 것! 돌아리에서 만나요.' : "Everything I need! Let's meet at Doldari."}
          </div>
          )}

          <button onClick={handleYoutubeToggle} className="youtube-toggle-button">
            {showYoutube ? 
              (language === 'KR' ? 'Youtube 숨기기' : 'Hide Youtube') : 
              (language === 'KR' ? 'Youtube 보기' : 'Show Youtube')
            }
          </button>


          {user && !user.uid.startsWith('uk_') ? (
            <div className="user-section">
              
              <button className='logout-button' onClick={handleLogout}> {language === 'KR' ? '로그아웃' : 'Logout'} </button>
              {user?.profile_picture_url && (
                <div className="profile-container">
                  <span className="user-display-name">{user.displayName}</span>
                </div>
              )}
            </div>
          ) : (
            <div>
              <button onClick={handleGoogleLogin} className="googleLogin-button">
                {language === 'KR' ? '구글 로그인' : 'Google Login'}
              </button>
            </div>
          )}  
        </div>
        
        <div className="content">    
          {/* 최대 5초 후에 강제로 컨텐츠 표시 */}
          {useEffect(() => {
            const timer = setTimeout(() => {
              if (isLoading || !dataReady) {
                console.log("Force loading complete after timeout");
                setDataReady(true);
                setIsLoading(false);
              }
            }, 5000);
            return () => clearTimeout(timer);
          }, [isLoading, dataReady])}
          
          {isLoading || !dataReady ? (
            <LoadingScreen />
          ) : (
            <Routes>
              <Route path="/" element={
                <Home 
                  language={language || 'KR'} 
                  user={user} 
                  countryCode={countryCode || 'UNKNOWN'} 
                  userIp={userIp || '0.0.0.0'}
                  showYoutube={showYoutube}
                />
              } />

              <Route path="/homeBookmark" element={<HomeBookmark language={language} user={user}/>} />
              <Route path="/homeLearnPlay" element={<HomeLearnPlay language={language} user={user}/>} />
              <Route path="/homeUtility" element={<HomeUtility language={language} user={user}/>} />
              <Route path="/homeShared" element={<HomeShared language={language} user={user}/>} />

              {/* 유튜브 공유 라우트 추가 */}
              <Route path="/homeYoutube" element={
                <YoutubeSharePage 
                  language={language} 
                  user={user} 
                  SERVER_ROOT={SERVER_ROOT}
                />
              } />

              <Route path="/intro" element={<Intro language={language} />} />
              <Route path="/diary" element={<Diary language={language} user={user}/>} />
              <Route path="/Imageconvert" element={<ImageConvert language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} />
              <Route path="/manage" element={<Manage language={language} user={user}/>} />
              <Route path="/headsup" element={<HeadsUp language={language} user={user}/>} /> 

              <Route path="/headsupbasic" element={<HeadsUpBasic language={language} user={user}/>} />

              <Route path="/wordstudytoeic" element={<WordStudyToeic language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} />  
              <Route path="/wordstudygre" element={<WordStudyGRE language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} />  
              <Route path="/wordstudysat" element={<WordStudySAT language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} />  
              <Route path="/wordstudyhs" element={<WordStudyHS language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} /> 

              <Route path="/clipboard" element={<Clipboard language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} />
              <Route path="/clipboard/diary/:id" element={<DiaryDetail language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} />
              <Route path="/watermark" element={<WaterMark language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} /> 
              <Route path="/scanPage" element={<ScanPage language={language} user={user}/>} /> 
              <Route path="/homehuggingface" element={<Homehuggingface language={language} user={user}/>} /> 
              <Route path="/gentoken" element={<GenToken language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} />
              <Route path="/MusicPlay" element={<MusicPlay language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} />


              <Route path="/speechtotext" element={<SpeechToText language={language} user={user}/>} /> 

              <Route path="/qr" element={<QRclient language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'} />} />
              <Route path="/qr/view" element={<QRclient view={true} language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'} />} />
              <Route path="/qr/templates" element={<QRclient templates={true} language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'} />} />  
              <Route path="/qrScanner" element={<QRScanner language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'} />} />
              <Route path="/directQRCreator" element={<DirectQRCreator language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'} />} />
              <Route path="/HFLedger" element={<HFLedger language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'} />} />
              <Route path="/YoutubePlay" element={
                <YoutubePlay 
                  language={language || 'KR'} 
                  user={user} 
                  countryCode={countryCode || 'UNKNOWN'} 
                  userIp={userIp || '0.0.0.0'}
                  SERVER_ROOT={SERVER_ROOT}
                />
              } />
              // App.js의 Routes 섹션에 추가할 라우트
              <Route path="/thumbnail" element={
                <Thumbnail 
                  language={language || 'KR'} 
                  user={user} 
                  countryCode={countryCode || 'UNKNOWN'} 
                  userIp={userIp || '0.0.0.0'}
                />
              } />
              <Route path="/blogEditor" element={
                <BlogEditor 
                  language={language || 'KR'} 
                  user={user} 
                  countryCode={countryCode || 'UNKNOWN'} 
                  userIp={userIp || '0.0.0.0'}
                />
              } />
              <Route path="/convertToCanon" element={<ConvertToCanon language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} />
              <Route path="/worldlandcafe" element={<WorldLandCafe language={language} user={user}/>} />
              <Route path="/guitarSimulator" element={<GuitarSimulator language={language} user={user} countryCode={countryCode || 'UNKNOWN'} userIp={userIp || '0.0.0.0'}/>} />
              <Route path="/audioSpectrum" element={
                <AudioSpectrum 
                  language={language || 'KR'} 
                  user={user} 
                  countryCode={countryCode || 'UNKNOWN'} 
                  userIp={userIp || '0.0.0.0'}
                />
              } />
          </Routes>
          
          )}
        </div>
      </div>  
    </Router>  
  );
}

export default App;